import React from "react";
import { useMsal } from "@azure/msal-react";

import Home from "layouts/SharpWatchLayouts/home";
import TheProblem from "layouts/SharpWatchLayouts/theproblem";
import TheSolution from "layouts/SharpWatchLayouts/thesolution";
import SharpWatchIsVetted from "layouts/SharpWatchLayouts/sharpwatchisvetted";
import Deployments from "layouts/SharpWatchLayouts/deployments";
import SignIn from "layouts/authentication/sign-in";

// @mui icons
import Icon from "@mui/material/Icon";

function RoutesList() {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const userRoles = account?.idTokenClaims?.roles || [];

  let routes = [];

  routes.push(
    {
      type: "collapse",
      name: "Home",
      key: "home",
      icon: <Icon fontSize="small">home</Icon>,
      route: "/home",
      allowedRoles: ["ADMIN", "HomePage"], // <--- This is what enables filtering
      component: <Home />,
    },
    {
      type: "collapse",
      name: "The Problem",
      key: "theproblem",
      icon: <Icon fontSize="small">help_outline</Icon>,
      route: "/theproblem",
      allowedRoles: ["ADMIN", "ProblemPage"],
      component: <TheProblem />,
    },
    {
      type: "collapse",
      name: "The Solution",
      key: "thesolution",
      icon: <Icon fontSize="small">task_alt</Icon>,
      route: "/thesolution",
      allowedRoles: ["ADMIN", "SolutionPage"],
      component: <TheSolution />,
    },
    {
      type: "collapse",
      name: "SharpWatch is Vetted",
      key: "sharpwatchisvetted",
      icon: <Icon fontSize="small">verified_user</Icon>,
      route: "/sharpwatchisvetted",
      allowedRoles: ["ADMIN", "SharpwatchisVetted"],
      component: <SharpWatchIsVetted />,
    },
    {
      type: "collapse",
      name: "Deployments",
      key: "deployments",
      icon: <Icon fontSize="small">place</Icon>,
      route: "/deployments",
      allowedRoles: ["ADMIN", "Deployments"],
      component: <Deployments />,
    },

    // Authentication routes are public, so no allowedRoles here:
    {
      route: "/authentication/sign-in",
      component: <SignIn />,
    }
    // {
    //   route: "/authentication/sign-out",
    //   component: <SignOut />,
    // }
  );

  return routes;
}

export default RoutesList;
